import React, {useEffect, useState} from 'react'
import {
  getConfigurationByName,
  updateConfigurationByConfigID,
} from '../../../../../../API/api-endpoint'
import ToastUtils, {ErrorToastUtils} from '../../../../../../utils/ToastUtils'

const RandomAudioVideoCallPlugin = () => {
  const [configID, setConfigId] = useState(0)
  const [config, setConfig] = useState<any>({
    isRandomAudioCallEnabled: false,
    isRandomVideoCallEnabled: false,
    verifiedUserOnlyRandomAudioCall: false,
    verifiedUserOnlyRandomVideoCall: false,
    enableCreditsPerMinAudio: false,
    enableCreditsPerMinVideo: false,
    chargeCreditsPerMinAudio: 0,
    chargeCreditsPerMinVideo: 0,
    chargeCreditsGenderAudio: 1, // 1=Male, 2=Female, 3=Both
    chargeCreditsGenderVideo: 1,
    transferRandomAudioCallCredits: false,
    transferRandomVideoCallCredits: false,
    transferCoinsPercentageAudio: 100,
    transferCoinsPercentageVideo: 100,
    transferFreeCoinsAudio: false,
    transferFreeCoinsVideo: false,
    freeCoinsTransferValueAudio: 0,
    freeCoinsTransferValueVideo: 0,
    freeMinutesVideoCall: 0,
    freeMinutesAudioCall: 0,
    searchingBuddiesSeconds: 30,
    isMultiDeviceFreeMinutesActive: false,
  })

  useEffect(() => {
    getConfiguration()
  }, [])

  const handleChange = (event: any) => {
    let name = event.target.name
    let type = event.target.type
    let value = type === 'checkbox' ? event.target.checked : event.target.value

    if (
      name === 'chargeCreditsPerMinAudio' ||
      name === 'chargeCreditsPerMinVideo' ||
      name === 'transferCoinsPercentageAudio' ||
      name === 'transferCoinsPercentageVideo' ||
      name === 'freeCoinsTransferValueAudio' ||
      name === 'freeCoinsTransferValueVideo' ||
      name === 'freeMinutesVideoCall' ||
      name === 'freeMinutesAudioCall' ||
      name === 'searchingBuddiesSeconds'
    ) {
      setConfig({...config, [name]: Number(value)})
    } else if (name === 'chargeCreditsGenderAudio' || name === 'chargeCreditsGenderVideo') {
      setConfig({...config, [name]: Number(value)})
      updateConfiguration({...config, [name]: Number(value)})
    } else {
      setConfig({...config, [name]: value})
      updateConfiguration({...config, [name]: value})
    }
  }

  const [isProfileVerificationEnabled, setIsProfileVerificationEnabled] = useState(true);

  const getConfiguration = async () => {
    let verificationResult = await getConfigurationByName('verification')
    if (verificationResult.success && verificationResult.data) {
      let parsedVerification = JSON.parse(verificationResult.data.values)
      setIsProfileVerificationEnabled(parsedVerification.isEnable)
    }

    let result = await getConfigurationByName('random-audio-video-call')
    if (result.success && result.data) {
      let parsedData = JSON.parse(result.data.values)
      setConfigId(result.data.id)
      setConfig({
        isRandomAudioCallEnabled: parsedData?.isRandomAudioCallEnabled ?? false,
        isRandomVideoCallEnabled: parsedData?.isRandomVideoCallEnabled ?? false,
        verifiedUserOnlyRandomAudioCall: parsedData?.verifiedUserOnlyRandomAudioCall ?? false,
        verifiedUserOnlyRandomVideoCall: parsedData?.verifiedUserOnlyRandomVideoCall ?? false,
        enableCreditsPerMinAudio: parsedData?.enableCreditsPerMinAudio ?? false,
        enableCreditsPerMinVideo: parsedData?.enableCreditsPerMinVideo ?? false,
        chargeCreditsPerMinAudio: parsedData?.chargeCreditsPerMinAudio ?? 0,
        chargeCreditsPerMinVideo: parsedData?.chargeCreditsPerMinVideo ?? 0,
        chargeCreditsGenderAudio: parsedData?.chargeCreditsGenderAudio ?? 1,
        chargeCreditsGenderVideo: parsedData?.chargeCreditsGenderVideo ?? 1,
        transferRandomAudioCallCredits: parsedData?.transferRandomAudioCallCredits ?? false,
        transferRandomVideoCallCredits: parsedData?.transferRandomVideoCallCredits ?? false,
        transferCoinsPercentageAudio: parsedData?.transferCoinsPercentageAudio ?? 100,
        transferCoinsPercentageVideo: parsedData?.transferCoinsPercentageVideo ?? 100,
        transferFreeCoinsAudio: parsedData?.transferFreeCoinsAudio ?? false,
        transferFreeCoinsVideo: parsedData?.transferFreeCoinsVideo ?? false,
        freeCoinsTransferValueAudio: parsedData?.freeCoinsTransferValueAudio ?? 0,
        freeCoinsTransferValueVideo: parsedData?.freeCoinsTransferValueVideo ?? 0,
        freeMinutesVideoCall: parsedData?.freeMinutesVideoCall ?? 0,
        freeMinutesAudioCall: parsedData?.freeMinutesAudioCall ?? 0,
        searchingBuddiesSeconds: parsedData?.searchingBuddiesSeconds ?? 30,
        isMultiDeviceFreeMinutesActive: parsedData?.isMultiDeviceFreeMinutesActive ?? false,
      })
    }
  }

  const onBlurUpdate = () => {
    updateConfiguration(config)
  }

  const updateConfiguration = async (updatedConfig: any) => {
    let result = await updateConfigurationByConfigID(configID, updatedConfig, null)
    if (result.success) {
      ToastUtils({type: 'success', message: 'Configuration Saved SuccessFully'})
    } else {
      ErrorToastUtils()
    }
  }

  return (
    <div className='row g-5'>
      {/* Random Audio Call Card */}
      <div className='col-lg-6'>
        <div className='card shadow-sm h-100'>
          <div className='card-header border-0 bg-light-primary py-5'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bold text-primary fs-3'>
                <i className='fa-solid fa-phone me-2 text-primary'></i>
                Random Audio Call Settings
              </span>
              <span className='text-muted mt-1 fw-semibold fs-7'>
                Manage audio calling settings and coin requirements
              </span>
            </h3>
          </div>

          <div className='card-body'>
            <div className='d-flex flex-column gap-6'>
              {/* Enable Switch */}
              <div className='d-flex align-items-center justify-content-between p-4 bg-light rounded'>
                <div>
                  <h5 className='fw-bold mb-1 text-dark'>Enable Random Audio Call</h5>
                  <span className='text-muted fs-7'>Toggle to enable or disable audio match calling</span>
                </div>
                <div className='form-check form-switch form-check-custom form-check-solid'>
                  <input
                    className='form-check-input h-25px w-45px'
                    type='checkbox'
                    role='switch'
                    name='isRandomAudioCallEnabled'
                    checked={config.isRandomAudioCallEnabled}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Verified Switch */}
              <div className='d-flex align-items-center justify-content-between p-4 bg-light rounded'>
                <div>
                  <h5 className='fw-bold mb-1 text-dark'>Verified User Can Only call</h5>
                  <span className='text-muted fs-7'>Only profile-verified users can perform random audio calls</span>
                  {!isProfileVerificationEnabled && (
                    <span className='text-danger d-block mt-2' style={{fontSize: '0.85rem'}}>
                      You have to start profile verification system in verification plugins to use this feature.
                    </span>
                  )}
                </div>
                <div className='form-check form-switch form-check-custom form-check-solid'>
                  <input
                    className='form-check-input h-25px w-45px'
                    type='checkbox'
                    role='switch'
                    name='verifiedUserOnlyRandomAudioCall'
                    checked={isProfileVerificationEnabled && config.verifiedUserOnlyRandomAudioCall}
                    onChange={handleChange}
                    disabled={!isProfileVerificationEnabled}
                  />
                </div>
              </div>

              {/* Charge Credits Switch */}
              <div className='d-flex align-items-center justify-content-between p-4 bg-light rounded'>
                <div>
                  <h5 className='fw-bold mb-1 text-dark'>Enable Credits Per Minute</h5>
                  <span className='text-muted fs-7'>Deduct coins for each active calling minute</span>
                </div>
                <div className='form-check form-switch form-check-custom form-check-solid'>
                  <input
                    className='form-check-input h-25px w-45px'
                    type='checkbox'
                    role='switch'
                    name='enableCreditsPerMinAudio'
                    checked={config.enableCreditsPerMinAudio}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Charge details container */}
              <div className='border border-dashed border-primary rounded p-5 bg-light bg-opacity-10 d-flex flex-column gap-4'>
                <div>
                  <label className='form-label fw-bold text-dark fs-6'>Charge Credits Per Minute</label>
                  <div className='input-group'>
                    <input
                      type='number'
                      className='form-control form-control-solid'
                      placeholder='Amount'
                      name='chargeCreditsPerMinAudio'
                      value={config.chargeCreditsPerMinAudio}
                      onChange={handleChange}
                      onBlur={onBlurUpdate}
                      disabled={!config.enableCreditsPerMinAudio}
                    />
                    <span className='input-group-text border-0 fw-bold'>coins</span>
                  </div>
                </div>

                <div>
                  <label className='form-label fw-bold text-dark fs-6'>Charge to Specific Gender</label>
                  <select
                    className='form-select form-select-solid'
                    name='chargeCreditsGenderAudio'
                    value={config.chargeCreditsGenderAudio}
                    onChange={handleChange}
                    disabled={!config.enableCreditsPerMinAudio}
                  >
                    <option value={1}>Male</option>
                    <option value={2}>Female</option>
                  </select>
                </div>
              </div>

              {/* Transfer Credits Switch */}
              <div className='d-flex align-items-center justify-content-between p-4 bg-light rounded'>
                <div>
                  <h5 className='fw-bold mb-1 text-dark'>Transfer Coins to Recipient</h5>
                  <span className='text-muted fs-7'>Transfer matching percentage of charged coins to called buddy</span>
                </div>
                <div className='form-check form-switch form-check-custom form-check-solid'>
                  <input
                    className='form-check-input h-25px w-45px'
                    type='checkbox'
                    role='switch'
                    name='transferRandomAudioCallCredits'
                    checked={config.transferRandomAudioCallCredits}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className='border border-dashed border-info rounded p-5 bg-light bg-opacity-10'>
                <label className='form-label fw-bold text-dark fs-6'>Coins Transfer Percentage</label>
                <div className='input-group'>
                  <input
                    type='number'
                    className='form-control form-control-solid'
                    placeholder='100'
                    max={100}
                    min={0}
                    name='transferCoinsPercentageAudio'
                    value={config.transferCoinsPercentageAudio}
                    onChange={handleChange}
                    onBlur={onBlurUpdate}
                    disabled={!config.transferRandomAudioCallCredits}
                  />
                  <span className='input-group-text border-0 fw-bold'>%</span>
                </div>
              </div>

              {/* Transfer Free Coins Switch */}
              <div className='d-flex align-items-center justify-content-between p-4 bg-light rounded'>
                <div>
                  <h5 className='fw-bold mb-1 text-dark'>Transfer Free Coins to Recipient</h5>
                  <span className='text-muted fs-7'>Transfer matching value of free minutes coins to called buddy</span>
                </div>
                <div className='form-check form-switch form-check-custom form-check-solid'>
                  <input
                    className='form-check-input h-25px w-45px'
                    type='checkbox'
                    role='switch'
                    name='transferFreeCoinsAudio'
                    checked={config.transferFreeCoinsAudio}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className='border border-dashed border-info rounded p-5 bg-light bg-opacity-10'>
                <label className='form-label fw-bold text-dark fs-6'>Free Coins Transfer value</label>
                <div className='input-group'>
                  <input
                    type='number'
                    className='form-control form-control-solid'
                    placeholder='0'
                    min={0}
                    name='freeCoinsTransferValueAudio'
                    value={config.freeCoinsTransferValueAudio}
                    onChange={handleChange}
                    onBlur={onBlurUpdate}
                    disabled={!config.transferFreeCoinsAudio}
                  />
                  <span className='input-group-text border-0 fw-bold'>coins / min</span>
                </div>
              </div>

              {/* Free Minutes */}
              <div>
                <label className='form-label fw-bold text-dark fs-6'>Free Minutes in Audio Call</label>
                <div className='input-group'>
                  <input
                    type='number'
                    className='form-control form-control-solid'
                    placeholder='0'
                    min={0}
                    name='freeMinutesAudioCall'
                    value={config.freeMinutesAudioCall}
                    onChange={handleChange}
                    onBlur={onBlurUpdate}
                  />
                  <span className='input-group-text border-0 fw-bold'>minutes</span>
                </div>
                <span className='text-muted fs-7 d-block mt-1'>
                  Number of starting minutes that are completely free of charge
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Random Video Call Card */}
      <div className='col-lg-6'>
        <div className='card shadow-sm h-100'>
          <div className='card-header border-0 bg-light-danger py-5'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bold text-danger fs-3'>
                <i className='fa-solid fa-video me-2 text-danger'></i>
                Random Video Call Settings
              </span>
              <span className='text-muted mt-1 fw-semibold fs-7'>
                Manage video calling settings and coin requirements
              </span>
            </h3>
          </div>

          <div className='card-body'>
            <div className='d-flex flex-column gap-6'>
              {/* Enable Switch */}
              <div className='d-flex align-items-center justify-content-between p-4 bg-light rounded'>
                <div>
                  <h5 className='fw-bold mb-1 text-dark'>Enable Random Video Call</h5>
                  <span className='text-muted fs-7'>Toggle to enable or disable video match calling</span>
                </div>
                <div className='form-check form-switch form-check-custom form-check-solid'>
                  <input
                    className='form-check-input h-25px w-45px'
                    type='checkbox'
                    role='switch'
                    name='isRandomVideoCallEnabled'
                    checked={config.isRandomVideoCallEnabled}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Verified Switch */}
              <div className='d-flex align-items-center justify-content-between p-4 bg-light rounded'>
                <div>
                  <h5 className='fw-bold mb-1 text-dark'>Verified User Can Only call</h5>
                  <span className='text-muted fs-7'>Only profile-verified users can perform random video calls</span>
                  {!isProfileVerificationEnabled && (
                    <span className='text-danger d-block mt-2' style={{fontSize: '0.85rem'}}>
                      You have to start profile verification system in verification plugins to use this feature.
                    </span>
                  )}
                </div>
                <div className='form-check form-switch form-check-custom form-check-solid'>
                  <input
                    className='form-check-input h-25px w-45px'
                    type='checkbox'
                    role='switch'
                    name='verifiedUserOnlyRandomVideoCall'
                    checked={isProfileVerificationEnabled && config.verifiedUserOnlyRandomVideoCall}
                    onChange={handleChange}
                    disabled={!isProfileVerificationEnabled}
                  />
                </div>
              </div>

              {/* Charge Credits Switch */}
              <div className='d-flex align-items-center justify-content-between p-4 bg-light rounded'>
                <div>
                  <h5 className='fw-bold mb-1 text-dark'>Enable Credits Per Minute</h5>
                  <span className='text-muted fs-7'>Deduct coins for each active calling minute</span>
                </div>
                <div className='form-check form-switch form-check-custom form-check-solid'>
                  <input
                    className='form-check-input h-25px w-45px'
                    type='checkbox'
                    role='switch'
                    name='enableCreditsPerMinVideo'
                    checked={config.enableCreditsPerMinVideo}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Charge details container */}
              <div className='border border-dashed border-danger rounded p-5 bg-light bg-opacity-10 d-flex flex-column gap-4'>
                <div>
                  <label className='form-label fw-bold text-dark fs-6'>Charge Credits Per Minute</label>
                  <div className='input-group'>
                    <input
                      type='number'
                      className='form-control form-control-solid'
                      placeholder='Amount'
                      name='chargeCreditsPerMinVideo'
                      value={config.chargeCreditsPerMinVideo}
                      onChange={handleChange}
                      onBlur={onBlurUpdate}
                      disabled={!config.enableCreditsPerMinVideo}
                    />
                    <span className='input-group-text border-0 fw-bold'>coins</span>
                  </div>
                </div>

                <div>
                  <label className='form-label fw-bold text-dark fs-6'>Charge to Specific Gender</label>
                  <select
                    className='form-select form-select-solid'
                    name='chargeCreditsGenderVideo'
                    value={config.chargeCreditsGenderVideo}
                    onChange={handleChange}
                    disabled={!config.enableCreditsPerMinVideo}
                  >
                    <option value={1}>Male</option>
                    <option value={2}>Female</option>
                  </select>
                </div>
              </div>

              {/* Transfer Credits Switch */}
              <div className='d-flex align-items-center justify-content-between p-4 bg-light rounded'>
                <div>
                  <h5 className='fw-bold mb-1 text-dark'>Transfer Coins to Recipient</h5>
                  <span className='text-muted fs-7'>Transfer matching percentage of charged coins to called buddy</span>
                </div>
                <div className='form-check form-switch form-check-custom form-check-solid'>
                  <input
                    className='form-check-input h-25px w-45px'
                    type='checkbox'
                    role='switch'
                    name='transferRandomVideoCallCredits'
                    checked={config.transferRandomVideoCallCredits}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className='border border-dashed border-info rounded p-5 bg-light bg-opacity-10'>
                <label className='form-label fw-bold text-dark fs-6'>Coins Transfer Percentage</label>
                <div className='input-group'>
                  <input
                    type='number'
                    className='form-control form-control-solid'
                    placeholder='100'
                    max={100}
                    min={0}
                    name='transferCoinsPercentageVideo'
                    value={config.transferCoinsPercentageVideo}
                    onChange={handleChange}
                    onBlur={onBlurUpdate}
                    disabled={!config.transferRandomVideoCallCredits}
                  />
                  <span className='input-group-text border-0 fw-bold'>%</span>
                </div>
              </div>

              {/* Transfer Free Coins Switch */}
              <div className='d-flex align-items-center justify-content-between p-4 bg-light rounded'>
                <div>
                  <h5 className='fw-bold mb-1 text-dark'>Transfer Free Coins to Recipient</h5>
                  <span className='text-muted fs-7'>Transfer matching value of free minutes coins to called buddy</span>
                </div>
                <div className='form-check form-switch form-check-custom form-check-solid'>
                  <input
                    className='form-check-input h-25px w-45px'
                    type='checkbox'
                    role='switch'
                    name='transferFreeCoinsVideo'
                    checked={config.transferFreeCoinsVideo}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className='border border-dashed border-info rounded p-5 bg-light bg-opacity-10'>
                <label className='form-label fw-bold text-dark fs-6'>Free Coins Transfer value</label>
                <div className='input-group'>
                  <input
                    type='number'
                    className='form-control form-control-solid'
                    placeholder='0'
                    min={0}
                    name='freeCoinsTransferValueVideo'
                    value={config.freeCoinsTransferValueVideo}
                    onChange={handleChange}
                    onBlur={onBlurUpdate}
                    disabled={!config.transferFreeCoinsVideo}
                  />
                  <span className='input-group-text border-0 fw-bold'>coins / min</span>
                </div>
              </div>

              {/* Free Minutes */}
              <div>
                <label className='form-label fw-bold text-dark fs-6'>Free Minutes in Video Call</label>
                <div className='input-group'>
                  <input
                    type='number'
                    className='form-control form-control-solid'
                    placeholder='0'
                    min={0}
                    name='freeMinutesVideoCall'
                    value={config.freeMinutesVideoCall}
                    onChange={handleChange}
                    onBlur={onBlurUpdate}
                  />
                  <span className='input-group-text border-0 fw-bold'>minutes</span>
                </div>
                <span className='text-muted fs-7 d-block mt-1'>
                  Number of starting minutes that are completely free of charge
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* General Settings Card */}
      <div className='col-12'>
        <div className='card shadow-sm'>
          <div className='card-header border-0 bg-light-warning py-5'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bold text-warning fs-3'>
                <i className='fa-solid fa-gear me-2 text-warning'></i>
                General Match Settings
              </span>
              <span className='text-muted mt-1 fw-semibold fs-7'>
                Global settings for the matching algorithm
              </span>
            </h3>
          </div>

          <div className='card-body'>
            <div className='col-md-6'>
              <label className='form-label fw-bold text-dark fs-6'>Searching Buddies Duration</label>
              <div className='input-group'>
                <input
                  type='number'
                  className='form-control form-control-solid'
                  placeholder='30'
                  min={5}
                  name='searchingBuddiesSeconds'
                  value={config.searchingBuddiesSeconds}
                  onChange={handleChange}
                  onBlur={onBlurUpdate}
                />
                <span className='input-group-text border-0 fw-bold'>seconds</span>
              </div>
              <span className='text-muted fs-7 d-block mt-1'>
                Timeout interval while searching for a matching call partner online
              </span>
            </div>

            {/* Enable Multi Device Free Minutes Switch */}
            <div className='d-flex align-items-center justify-content-between p-4 bg-light rounded mt-5'>
              <div>
                <h5 className='fw-bold mb-1 text-dark'>Enable Multi Device Free Minutes</h5>
                <span className='text-muted fs-7'>Allow free minutes for multiple accounts on the same device</span>
              </div>
              <div className='form-check form-switch form-check-custom form-check-solid'>
                <input
                  className='form-check-input h-25px w-45px'
                  type='checkbox'
                  role='switch'
                  name='isMultiDeviceFreeMinutesActive'
                  checked={config.isMultiDeviceFreeMinutesActive}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RandomAudioVideoCallPlugin
